"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tapis Applications API
 * The Tapis Applications API provides for management of Tapis applications including permissions.
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var runtime_1 = require("../runtime");
var _1 = require("./");
function ReqPatchAppFromJSON(json) {
    return ReqPatchAppFromJSONTyped(json, false);
}
exports.ReqPatchAppFromJSON = ReqPatchAppFromJSON;
function ReqPatchAppFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'description': !runtime_1.exists(json, 'description') ? undefined : json['description'],
        'runtime': !runtime_1.exists(json, 'runtime') ? undefined : _1.RuntimeEnumFromJSON(json['runtime']),
        'runtimeVersion': !runtime_1.exists(json, 'runtimeVersion') ? undefined : json['runtimeVersion'],
        'runtimeOptions': !runtime_1.exists(json, 'runtimeOptions') ? undefined : (json['runtimeOptions'].map(_1.RuntimeOptionEnumFromJSON)),
        'containerImage': !runtime_1.exists(json, 'containerImage') ? undefined : json['containerImage'],
        'jobType': !runtime_1.exists(json, 'jobType') ? undefined : _1.JobTypeEnumFromJSON(json['jobType']),
        'maxJobs': !runtime_1.exists(json, 'maxJobs') ? undefined : json['maxJobs'],
        'maxJobsPerUser': !runtime_1.exists(json, 'maxJobsPerUser') ? undefined : json['maxJobsPerUser'],
        'strictFileInputs': !runtime_1.exists(json, 'strictFileInputs') ? undefined : json['strictFileInputs'],
        'jobAttributes': !runtime_1.exists(json, 'jobAttributes') ? undefined : _1.JobAttributesFromJSON(json['jobAttributes']),
        'tags': !runtime_1.exists(json, 'tags') ? undefined : json['tags'],
        'notes': !runtime_1.exists(json, 'notes') ? undefined : json['notes'],
    };
}
exports.ReqPatchAppFromJSONTyped = ReqPatchAppFromJSONTyped;
function ReqPatchAppToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'description': value.description,
        'runtime': _1.RuntimeEnumToJSON(value.runtime),
        'runtimeVersion': value.runtimeVersion,
        'runtimeOptions': value.runtimeOptions === undefined ? undefined : (value.runtimeOptions.map(_1.RuntimeOptionEnumToJSON)),
        'containerImage': value.containerImage,
        'jobType': _1.JobTypeEnumToJSON(value.jobType),
        'maxJobs': value.maxJobs,
        'maxJobsPerUser': value.maxJobsPerUser,
        'strictFileInputs': value.strictFileInputs,
        'jobAttributes': _1.JobAttributesToJSON(value.jobAttributes),
        'tags': value.tags,
        'notes': value.notes,
    };
}
exports.ReqPatchAppToJSON = ReqPatchAppToJSON;
